import React, { PureComponent } from 'react';
import ErrorInfo from '../../errorHandler/components/ErrorInfo';
import { connect } from 'react-redux';
import * as errorBoundaryActions from '../Actions';
import * as notificationActions from '../../notification/Actions';

class ErrorBoundary extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			error: '',
			errorInfo: '',
			hasError: false,
		};
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.errorMessage !== '') {
			return { hasError: true };
		}
		return null;
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		this.setState({ errorInfo });
	}

	clearError = () => {
		const { clearNotifications, setError } = this.props;
		clearNotifications();
		setError('');
		this.setState({ hasError: false });
	};

	render() {
		if (this.state.hasError) {
			return <ErrorInfo clearError={this.clearError} />;
		}
		return this.props.children;
	}
}

function mapStateToProps(state) {
	return {
		errorMessage: state.errorBoundaryReducer.error,
	};
}

const mapDispatchToProps = {
	setError: errorBoundaryActions.setError,
	clearNotifications: notificationActions.clearNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
